const projects = [
  {
    name: 'Voxxy',
    description: 'The operating system for recurring community events.',
    url: 'https://heyvoxxy.com',
    category: 'Startup',
    tech: ['React', 'Node.js', 'Ruby on Rails'],
  },
  {
    name: 'Fash-a-thon',
    description:
      'Co-produced a 6-day fashion design hackathon with 99 Yards, culminating in a YouTube live runway finale and winning looks featured in Brooklyn Fashion Week.',
    url:
      'https://www.linkedin.com/posts/hey-voxxy_heyvoxxy-brooklynfashionweek-activity-7452024681819295744-oKlS?utm_source=share&utm_medium=member_desktop&rcm=ACoAAA56CmABt_QI-ZXgbQvQPaqejKiFdbGhk9E',
    category: 'Event Production',
    tech: ['Live Production', 'Partnerships'],
    ctaLabel: 'View Recap →',
  },
  {
    name: 'Black Tech News',
    description: 'Aggregator for Black tech innovation stories.',
    url: 'https://www.blacktechnews.cc/',
    category: 'Side Project',
    tech: ['React', 'API'],
  },
  {
    name: 'Spin The Globe',
    description: 'Discover stories from around the world.',
    url: 'https://www.wolfdevelopmentstudio.com/spin-the-globe',
    category: 'Side Project',
    tech: ['React', 'API'],
  },
  {
    name: 'Kudos',
    description: 'Two-sided marketplace connecting parents with tutors.',
    url: 'https://kudos-tutor-student.vercel.app/',
    category: 'Hackathon Winner',
    tech: ['React', 'Node.js'],
  },
];

export default projects;
